import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./Style.css";
import "./Style.scss";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Withdraw from "./Component/Page/Withdraw";
import Deposit from "./Component/Page/Deposit";
import Withdrawalchat from "./Component/Page/Withdrawalchat";
import DepositchatSocket from "./Component/Page/DepositchatSocket";
import Linktable from "./Component/Page/Linktable";
import Scanner from "./Component/Page/Scanner";
import Usertable from "./Component/Page/Usertable";

import Header from "./Component/Header/Header";
import Admin from "./AdminLogin";
import Register from "./Register";
import Dashboard from './Dashboard/Dashboard'
import Dashsidebar from './Dashboard/Dashsidebar'
import Dashheader from './Dashboard/Dashheader'
import Dashfooter from './Dashboard/Dashfooter'
import Setting from './Component/Page/Setting'
import Bank from "./Component/Page/Bank";
import ForgetPass from "./ForgetPass";
function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <BrowserRouter>


      <Routes>
  <Route
    path="/*"
    element={
      <div className="Dasboarddesign">
        <Dashheader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <div className={`d-flex sidebarclosedesign`}>
          <Dashsidebar isOpen={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
          <div className={`dashboard-container dashboard w-100 margin-top ${sidebarOpen ? "open" : "closed"}`}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/Withdraw" element={<Withdraw />} />
              <Route path="/Bank" element={<Bank />} />
              <Route path="/Scanner" element={<Scanner />} />
              <Route path="/Deposit" element={<Deposit />} />
              <Route path="/Link" element={<Linktable />} />
              <Route path="/User" element={<Usertable />} />
              <Route path="/Setting" element={<Setting />} />
              
            </Routes>
          </div>
        </div>
        <Dashfooter />
      </div>
    }
  />

  {/* Routes without Header & Sidebar */}
  <Route path="/Withdrawalchat" element={<Withdrawalchat />} />
  <Route path="/DepositchatSocket" element={<DepositchatSocket />} />
        <Route path="/" element={<Admin />} />
        <Route path="/forget-password" element={<ForgetPass />} /> 
        {/* <Route path="/HomePage" element={<HomePage />} /> */}

        <Route path="/register" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;